import { api } from '@config/api';
import type { EnderecoPorCep } from '../types/Formulario';

export const cepService = {
  /** `cep` já normalizado (8 dígitos): a consulta é sempre pela API, nunca pelo navegador (R3). */
  consultar: (cep: string) => api.get<EnderecoPorCep>(`/enderecos/cep/${cep}`).then((r) => r.data),
};
